import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { useQueryClient } from '@tanstack/react-query';
import { PART_FINDER_REPORTS_QUERY_KEY } from '@/hooks/api/part-finder-reports/query';
import { BulkDeleteModal } from '../modals/BulkDeleteModal';

export const BulkDeleteReportsModal = ({
  open,
  onClose,
  selectedReportIds,
  onDeleteComplete,
}: {
  open: boolean;
  onClose: () => void;
  selectedReportIds: string[];
  onDeleteComplete: () => void;
}) => {
  const { getTenantId } = useTenants();
  const queryClient = useQueryClient();

  const handleDeleteItem = async ({ id }: { id: string }) => {
    const tenantId = getTenantId();
    await api.tenants.deletePartFinderReport(tenantId, id);
  };

  const handleDeleteComplete = () => {
    queryClient.resetQueries({ queryKey: [PART_FINDER_REPORTS_QUERY_KEY], exact: false });
    onDeleteComplete();
  };

  return (
    <BulkDeleteModal
      open={open}
      onClose={onClose}
      selectedItems={selectedReportIds.map(id => ({ id }))}
      onDeleteComplete={handleDeleteComplete}
      deleteItem={handleDeleteItem}
      itemLabel={{ singular: 'report', plural: 'reports' }}
    />
  );
};
